//定义一些全局变量

export default {
    //允许组件有自己的命名空间，以和其他做区分
    namespaced: true,
    state: {
        //数据对象列表
        data_object_list: [
            {
                id: 0, name: "客户公司", value: "customer_company", families: [
                    { id: 1, label: "客户类型", value: "type" }
                ]
            },
            {
                id: 1, name: "物料", value: "material", families: [
                    { id: 1, label: "物料类型", value: "type" }
                ]
            },
            {
                id: 2, name: "采购订单", value: "po", families: [
                    { id: 1, label: "单地址", value: "single_address" },
                    { id: 2, label: "订单类型", value: "type" },
                ]
            },
            {
                id: 3, name: "项目", value: "project", families: [
                    { id: 1, label: "项目号", value: "project_num" },
                ]
            },
            {
                id: 4, name: "销售订单", value: "so", families: [
                    { id: 1, label: "订单类型", value: "type" },

                ]
            },
            {
                id: 5, name: "供应商公司", value: "supplier_company", families: [
                    { id: 1, label: "供应商分类", value: "type" },

                ]
            },
            /*暂时不用
            { id: 6, name: "库位", value: "warehouse",families:[
                {id:1,label:"库位分类",value:"type"},
            ] },
            */
            {
                id: 7, name: "ASN", value: "asn", families: [
                    { id: 1, label: "包装类型", value: "package_types" },
                ]
            },
        ],



        //定义发票类型
        invoice_types: [
            { id: 1, name: "增值税专用发票", value: "1" },
            { id: 2, name: "增值税普通发票", value: "2" },
        ],
        //货币类型
        currency_types: [
            { id: 1, name: "CNY", value: "CNY" },
            { id: 2, name: "USD", value: "USD" },
            { id: 3, name: "EUR", value: "EUR" },
        ],
        //状态类型
        status_types: [
            { id: 1, label: "草稿", value: "1" },
            { id: 2, label: "流程中", value: "2" },
            { id: 3, label: "发布", value: "3" }
        ],
        //生失效状态
        is_active_types: [
            { id: 1, label: "生效", value: "1" },
            { id: 2, label: "失效", value: "2" }
        ],
        //销售订单的状态
        so_status_types: [
            { id: 1, label: "草稿", value: "1" },
            { id: 2, label: "流程中", value: "2" },
            { id: 3, label: "发布", value: "3" },
            { id: 8, label: "部分已发", value: "8" },
            { id: 9, label: "全部已发", value: "9" },
            { id: 12, label: "部分已收", value: "12" },
            { id: 13, label: "全部已收", value: "13" }
        ],
        //采购订单的状态类型
        po_status_types: [
            { id: 1, label: "草稿", value: "1" },
            { id: 2, label: "流程中", value: "2" },
            { id: 3, label: "发布", value: "3" },
            { id: 5, label: "待供方确认", value: "5" },
            { id: 6, label: "计划待确认", value: "6" },
            { id: 7, label: "待发货", value: "7" },
            { id: 8, label: "部分已发", value: "8" },
            { id: 9, label: "全部已发", value: "9" },
            { id: 12, label: "部分已收", value: "12" },
            { id: 13, label: "全部已收", value: "13" }
        ],
        //采购收货单类型
        gr_types: [
            { id: 1, label: "ASN收货", value: "1" },

            { id: 2, label: "无ASN收货", value: "2" }
        ],
        //收货状态
        gr_accepted_types: [
            { id: 0, label: "未收货", value: "0" },
            { id: 1, label: "完全收货", value: "1" },
            { id: 2, label: "部分收货", value: "2" },
        ],
        //收货类型
        gr_purchase_types: [
            { id: 20, label: "采购收货", value: "20" },
            { id: 30, label: "外协收货", value: "30" }
        ],
        move_types: [
            //{ id: 1, label: "采购收货", value: "1" },
            { id: 2, label: "其他收货", value: "2" },
            { id: 3, label: "销售出库", value: "3" },
            //{ id: 4, label: "销售被退补发出库", value: "4" },
            { id: 5, label: "其他出库", value: "5" },
            { id: 6, label: "库存盘点", value: "6" },
            { id: 7, label: "库存调拨", value: "7" },
            //{ id: 8, label: "采购送达", value: "8" },
            //{ id: 9, label: "采购送达及收货", value: "9" },
            //{ id: 10, label: "采购待收退货", value: "10" },
            //{ id: 11, label: "客户收货单", value: "11" },
            //{ id: 12, label: "在途库存调整", value: "12" },
            { id: 13, label: "外协消耗", value: "13" },
            { id: 14, label: "收销售退货", value: "14" },

        ],
        is_used_types: [
            { id: 0, label: "未关联", value: "0" },
            { id: 1, label: "已关联", value: "1" },
        ],
        /*物料采购视图中的采购类型
        material_purchase_types: [
            //{ id: 10, label: "寄售", value: "10" },
            { id: 20, label: "外部采购", value: "20" },
            { id: 30, label: "外协", value: "30" },
        ],
        */
        //采购订单类型
        po_types: [
            { id: 20, label: "采购", value: "20" },
            { id: 30, label: "外协", value: "30" },
            //{ id: 90, label: "采购退货", value: "90" },
            //{ id: 4, label: "VMI-补货需求", value: "4" },
            //{ id: 5, label: "VMI-领用消耗", value: "5" },
            //{ id: 6, label: "VMI-退货", value: "6" },
            //{ id: 7, label: "VMI-回退", value: "7" },
        ],
        //采购类型
        purchase_types: [
            { id: 1, label: "采购订单", value: "1" },
            { id: 2, label: "VMI补货", value: "2" },
        ],

        //采购订单的跨公司交易分类
        trade_types: [
            { id: 1, label: "外部交易", value: "1" },
            { id: 2, label: "公司间交易", value: "2" },
        ],

        //BOM行中，采购状态字下拉列表
        purchase_type_options_in_bom: [
            //{ id: 0, label: "B", value: "B" },
            //{ id: 1, label: "C", value: "C" },
            { id: 2, label: "S", value: "S" },
        ],
        //BOM头的BOM用途
        bom_header_usage: [
            { id: 1, label: "委外生产", value: "1" },
        ],
        //物料分组的类型
        material_group_types: [
            { id: 1, label: "个人", value: "1" },
            { id: 2, label: "公共", value: "2" },
        ],
        //仓库/位置选项
        wh_root_types: [
            { id: 1, label: "仓库", value: "1" },
            { id: 2, label: "位置", value: "2" },
        ],
        //库位的虚拟/实物选项
        wh_style_types: [
            { id: 1, label: "虚拟", value: "1" },
            { id: 2, label: "实物", value: "2" },
        ],
        //库位的虚拟类型选项
        wh_virtual_types: [
            { id: 11, label: "客户类型", value: "11" },
            { id: 12, label: "供应商类型", value: "12" },
            { id: 13, label: "盘点用类型", value: "13" },
            { id: 14, label: "损耗类型", value: "14" },
            { id: 15, label: "消耗类型", value: "15" },
        ],
        //库位的实物类型选项
        wh_real_types: [
            { id: 21, label: "非限制类型", value: "21" },
            { id: 22, label: "待检类型", value: "22" },
            { id: 23, label: "冻结类型", value: "23" },
            { id: 24, label: "在途类型", value: "24" },
            { id: 25, label: "外协类型", value: "25" },
        ],
        //采购结算点类型
        purchase_payment_check_point_types: [
            { id: 1, label: "订单", value: "1" },
            { id: 2, label: "交货", value: "2" },
            { id: 3, label: "收货", value: "3" },
            //{ id: 4, label: "上线", value: "4" },
            //{ id: 5, label: "下线", value: "5" },
            { id: 6, label: "销售", value: "6" },
        ],
        //预付点类型
        prepay_types: [
            { id: 1, label: "订单", value: "1" },
            { id: 2, label: "交货", value: "2" },
        ],
        //支付方式
        purchase_payment_format_types: [
            { id: 1, label: "现汇", value: "1" },
            { id: 2, label: "承兑汇票", value: "2" },
            { id: 3, label: "信用证", value: "3" },
            { id: 4, label: "其他", value: "4" },
        ],
        //承兑汇票的周期列表选择
        acceptance_bill_cycle_list: [
            { id: 1, label: "30", value: 30 },
            { id: 2, label: "60", value: 60 },
            { id: 3, label: "90", value: 90 },
        ],

        //对账单状态类型
        bill_status_types: [
            { id: 1, label: "草稿", value: "1" },
            { id: 2, label: "流程中", value: "2" },
            { id: 3, label: "待确认", value: "3" },
            { id: 4, label: "待发票", value: "4" },
            { id: 5, label: "发票待确认", value: "5" },
            { id: 6, label: "待支付", value: "6" },
            { id: 7, label: "流程中", value: "7" },
            { id: 8, label: "已完成", value: "8" },
        ],
        //对账单行中的是否有预付的标记
        is_prepaid_types: [
            { id: 1, label: "有预付", value: "1" },
            { id: 2, label: "无预付", value: "2" },
        ],

        /*暂不需要，用status
        plm_interface_status_types: [
            { id: 1, label: "开启", value: "1" },
            { id: 2, label: "关闭", value: "2" }
        ],
        */

        //财务查询报表的类型列表
        financial_query_types: [
            { id: 1, label: "采购收货入库明细", value: "1" },
            { id: 2, label: "客户收货明细", value: "2" },
            //{ id: 3, label: "采购订单应付预估表", value: "3" },
        ],

        //客户收货差异原因分类
        deviation_types: [
            { id: 1, label: "损耗", value: "1" },
            { id: 2, label: "退回", value: "2" },
        ],

        //角色分类列表
        role_types: [
            { id: 1, label: "管理员", value: "admin" },
            { id: 2, label: "采购", value: "purchase" },
            { id: 3, label: "销售", value: "sales" },
            { id: 4, label: "物流", value: "logistic" },
            { id: 5, label: "财务", value: "finance" },
        ],

        //供应商银行账户类型
        supplier_bank_account_types: [
            { id: 1, label: "对公账户", value: "对公账户" },
            { id: 2, label: "个人账户", value: "个人账户" },
        ],

        //采购订单发布模式选项
        po_release_modes: [
            { id: 1, label: "一键发布", value: 1 },
            { id: 2, label: "流程发布", value: 2 },
        ],

        //物料视图类型选项列表
        material_view_types: [
            { id: 1, label: "物料基础数据", value: "materialMain" },
            { id: 2, label: "采购视图", value: "materialPurchaseView" },
            { id: 3, label: "销售视图", value: "materialSaleView" },
            { id: 4, label: "物流视图", value: "materialLogisticsView" },
        ],

    },
    mutations: {
        //暂时没有

    },
}